import React, {Component, Fragment} from 'react';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import BaseIconButton from '../../../components/button/BaseIconButton';
import Chevron from '../../../assets/images/chevron';
import Close from 'react-icons/lib/io/close';
import './style.scss';
import LinearProgress from '@material-ui/core/LinearProgress';
import MediaSelector from '../../../components/mediaSelector';
import {DeviceType} from '../../../constants/enums';
import {instructions} from '../../../themes/colors';
import {withStyles} from '@material-ui/core/styles';
import SvgIconButton from '../../../components/SvgIconButton';

const errorStr = '!';
const percentStr = '%';

const styles = () => ({
    secondaryLoader: {
        backgroundColor: instructions,
    }
});

@injectIntl
@inject('uploadsProgressStore')
@observer
class UploadsProgressContainer extends Component {
    @observable isShowList = true;

    @action toggleShowList = () => {
        this.isShowList = !this.isShowList;
    }

    render() {
        const {classes, uploadsProgressStore, intl: {formatMessage: translate}} = this.props;
        const {uploadsList, resetUploadsList} = uploadsProgressStore;
        const activeList = uploadsList.filter(upload => {return upload.progress !== -1 && upload.progress !== 100});

        return (
            <Fragment>
                <MediaSelector devices={[DeviceType.Desktop, DeviceType.Tablet]}>
                    {uploadsList.length ? (
                        <div className='uploads-container'>
                            <div className="header">
                                {activeList.length === 0 && <span className="header-text">{translate({id: 'uploadingProgress.headerDone'})}</span>}
                                {activeList.length > 0 && <span className="header-text">{translate({id: 'uploadingProgress.header'}, {itemCount: activeList.length})}</span>}
                                <div className="header-buttons">
                                    <BaseIconButton
                                        disableRipple
                                        className={`btn-toggle ${this.isShowList ? 'selected' : ''}`}
                                        viewBox="0 0 20 20"
                                        onClick={this.toggleShowList}
                                        icon={Chevron}
                                    />
                                    <SvgIconButton
                                        disableRipple
                                        containerClass={`btn-close ${activeList.length > 0 ? 'disabled' : ''}`}
                                        viewBox="0 0 20 20"
                                        onClick={resetUploadsList}
                                        disabled={activeList.length > 0}
                                        icon={<Close/>}
                                    />
                                </div>
                            </div>
                            {this.isShowList && uploadsList.map(upload => {
                                const isErr = upload.progress === -1;
                                const progressStr = isErr ? errorStr : upload.progress + percentStr;
                                return(<div className="item" key={upload.fileId}>
                                    <div className="name overflow-ellipsis">{upload.fileName}</div>
                                    <div title={upload.err || ''} className={`badge ${isErr ? 'error' : ''}`}>{progressStr}</div>
                                </div>);
                            })}
                        </div>
                    ) : null}
                </MediaSelector>
                <MediaSelector devices={[DeviceType.Mobile]}>
                    {activeList.length ? (
                        <Fragment>
                            <div className="uploads-container-mobile">
                                <div className="uploading-label-div">
                                    <span className="uploading-label">Uploading</span>
                                    <span className="uploading-progress">{activeList[0].progress + percentStr}</span>
                                </div>
                                <div className="uploading-progress-bar-div">
                                        <LinearProgress
                                            classes={{barColorPrimary: classes.secondaryLoader}}
                                            className="progress-bar"
                                            variant="determinate"
                                            value={activeList[0].progress}
                                        />
                                </div>
                            </div>
                        </Fragment>
                    ) : null}
                </MediaSelector>
            </Fragment>
    );
    }
}

export default withStyles(styles)(UploadsProgressContainer);
